import React, { useState } from "react";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [response, setResponse] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResponse(""); // Clear previous messages

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("subject", subject);
    formData.append("message", message);

    try {
      const res = await fetch("contact2.php", {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "application/json", // Ensures JSON response
        },
      });

      const text = await res.text(); // Read raw response
      console.log("Raw Response:", text); // Debugging

      if (!text) throw new Error("Empty response from server!");

      const result = JSON.parse(text); // Try parsing JSON

      if (res.ok && result.message) {
        setResponse(result.message);
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
      } else {
        throw new Error(result.error || "Something went wrong!");
      }
    } catch (error) {
      console.error("Error:", error);
      setResponse(error.message);
    }
  };

  return (
    <>
      <div className="container-fluid bg-breadcrumb contactbanner">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">
            Contact Us
          </h4>
        </div>
      </div>

      {/* Contact Form Section */}
      <section className="contact_area" id="contact" style={{ textAlign: "left", marginLeft: "10", paddingLeft: "20px" }}>
        <div className="container-fluid" style={{ display: "flex", justifyContent: "flex-start" }}>
          <div className="row">
            <div className="section-title2 wow zoomIn">
              <h2>Get in Touch</h2>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12"></div>
            <div className="col-md-4 col-sm-4 col-xs-12">
              <div className="contact">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="form-group col-md-12">
                      <input
                        className="form-control"
                        id="first-name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        name="name"
                        placeholder="Name"
                        required
                        type="text"
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <input
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Email"
                        required
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <input
                        className="form-control"
                        id="subject"
                        name="subject"
                        placeholder="Subject"
                        required
                        type="text"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <textarea
                        className="form-control"
                        id="description"
                        name="message"
                        placeholder="Your Message"
                        required
                        rows={6}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>
                    <div className="col-md-12 d-flex justify-content-center">
                      <div className="actions">
                        <input
                          className ="btn btn-lg btn-contact-bg"
                          id="submitButton"
                          name="submit"
                          title="Submit Your Message!"
                          type="submit"
                          value="Send message"
                    
                        />
                      </div>
                    </div>
                  </div>
                </form>
                {response && <p>{response}</p>}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid copyright py-3">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-6 text-center text-md-start mb-md-0">
                            <span className="text-body">
                                <i className="fas fa-copyright text-light me-1" />
                                2024 Celersoft. All rights reserved.
                            </span>
                        </div>
                        {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                    className="border-bottom text-primary"
                    href="https://htmlcodex.com"
                >
                    HTML Codex
                </a>{" "}
                Distributed By{" "}
                <a
                    className="border-bottom text-primary"
                    href="https://themewagon.com"
                >
                    ThemeWagon
                </a>


              </div> */}
                    </div>
                </div>
            </div>

      {/* Back to Top Button */}
      <button className="btn btn-primary btn-lg-square back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
        <i className="fa fa-arrow-up" />
      </button>
    </>
  );
};

export default Contact;
